import { useState } from "react";
import useApi from "./Api";

const useFormDataPost = () => {
  const [formDataPostError, setFormDataPostError] = useState("");
  const [formDataPostResult, setFormDataPostResult] = useState(null);

  const Api = useApi();

  const postFormData = async (url, formData) => {
    try {
      const response = await Api.post(
        url,
        formData,
        null, // ✅ No manual headers
        true // ✅ Mark as FormData
      );

      if (response) {
        setFormDataPostResult(response);
        setFormDataPostError(""); // Reset error on success
      } else {
        let errorMessage;
        try {
          let errorData = await response.json();
          errorMessage = `${errorData.title}: ${errorData.detail}`;
        } catch (parseError) {
          errorMessage =
            "Upload failed. Server returned an unexpected response.";
        }
        setFormDataPostError(errorMessage);
        throw new Error(errorMessage);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      setFormDataPostError(error.message || "An error occurred during upload.");
    }
  };

  return { postFormData, formDataPostResult, formDataPostError };
};

export default useFormDataPost;
